/** Agent-internal media inventory dumps that should not appear in user-facing chat. */
export const isAgentMediaInventoryMessage = (content: string): boolean => {
  const trimmed = content.trim();

  return trimmed.startsWith('Media Files Loaded for Processing') || trimmed.includes('## Known Media');
};
